import { readonly, shallowRef } from 'vue'
import { normalizeTonAddress } from '@/utils/ton-address'

export interface PersonalSession {
  wallet: string
  id: number
}

const session = shallowRef<PersonalSession | null>(null)
let generation = 0

// The application wallet binding owns this namespace; queries never own authentication.
export const personalSession = readonly(session)

export function setPersonalSession(address: string | null): void {
  const wallet = normalizeTonAddress(address)
  if (wallet === (session.value?.wallet ?? '')) return
  session.value = wallet ? { wallet, id: ++generation } : null
}

export function isCurrentPersonalSession(expected: PersonalSession | null): boolean {
  return expected !== null && expected.id === session.value?.id
}

export function requirePersonalSession(): PersonalSession {
  if (!session.value) throw new Error('Connect your wallet to continue.')
  return session.value
}

export function assertPersonalSession(expected: PersonalSession): void {
  if (!isCurrentPersonalSession(expected)) throw new Error('Wallet session changed.')
}
